import { Route, Routes } from 'react-router'
import ComparatorIndex from './Comparator/ComparatorIndex'
import ComparatorAdd from './Comparator/ComparatorAdd'

const ComparatorRouter = () => {
  return (
    <Routes>
      <Route exact path='' element={<ComparatorIndex />} />
      <Route path='add' element={<ComparatorAdd />} />
    </Routes>
  )
}

export default ComparatorRouter
